import { env } from "../utils/env";
import { PhaseTwo, PhaseTwoParameters } from "./models/PhaseTwo";
import { PhaseThree, PhaseThreeParameters } from "./models/PhaseThree";
import { PhaseFour, PhaseFourParamaters } from "./models/PhaseFour";
import {
    PhaseFile,
    PhaseExtraFile,
    PhaseFileParameters,
    PhaseExtraFileParameters,
} from "./models/PhaseFile";

export const ENABLE_ZOHO = env.int(process.env.REACT_APP_ENABLE_ZOHO);
export const ZOHO_CUSTOMER_BASE_PATH =
    "ux-consulta-contactos-vida-ley-empleados-vda/ecommerce-vida-ley-cliente/soporte-ti/v1/v1";
export const ZOHO_CREATE_CUSTOMER_BASE_PATH =
    "ux-registra-Contactos-vida-ley-empleados-vda/ecommerce-vida-ley-cliente/soporte-ti/v1/v1";
export const ZOHO_OPPORTUNITY_BASE_PATH =
    "ux-crea-leads-vida-ley-empleados-vda/ecommerce-vida-ley-cliente/soporte-ti/v1/v1";

export const ZOHO_PHASE_BASE_PATH =
    "ux-actualiza-leads-vida-ley-empleados-vda/ecommerce-vida-ley-cliente/soporte-ti/v1/v1";

export const ZOHO_FILE_BASE_PATH =
    "ux-Envio-adjuntos-vida-ley-empleados-vda/ecommerce-vida-ley-cliente/soporte-ti/v1/v1";

export const PRODUCT_NAME = "Vida Ley";

export const CHANNEL_DEFAULT = "Ecommerce";

export enum TYPE_PHASES {
    PHASE_TWO = "PHASE_TWO",
    PHASE_THREE = "PHASE_THREE",
    PHASE_FOUR = "PHASE_FOUR",
    PHASE_FILE = "PHASE_FILE",
    PHASE_EXTRA_FILE = "PHASE_EXTRA_FILE",
}

export const getDateFormat = (initialDate?: string): string => {
    const date = initialDate ? new Date(Date.parse(initialDate)) : new Date();
    return `${date.toISOString().split("T")[0]}T${(
        "00" + date.getHours()
    ).substr(-2)}:${("00" + date.getMinutes()).substr(-2)}:${(
        "00" + date.getSeconds()
    ).substr(-2)}.${("000" + date.getMilliseconds()).substr(-3)}-05:00`;
};

export const transformPhase = (
    phase: TYPE_PHASES,
    body:
        | PhaseTwoParameters
        | PhaseThreeParameters
        | PhaseFourParamaters
        | PhaseFileParameters
        | PhaseExtraFileParameters
) => {
    let entity = null;
    if (phase === TYPE_PHASES.PHASE_TWO) {
        entity = new PhaseTwo(body as PhaseTwoParameters); //done
    }
    if (phase === TYPE_PHASES.PHASE_THREE) {
        entity = new PhaseThree(body as PhaseThreeParameters); //done
    }
    if (phase === TYPE_PHASES.PHASE_FOUR) {
        entity = new PhaseFour(body as PhaseFourParamaters); //done
    }
    if (phase === TYPE_PHASES.PHASE_FILE) {
        entity = new PhaseFile(body as PhaseFileParameters);
    }
    if (phase === TYPE_PHASES.PHASE_EXTRA_FILE) {
        entity = new PhaseExtraFile(body as PhaseExtraFileParameters);
    }
    return entity;
};

export const ZOHO_ECOMMERCE_NAME = env.string(
    process.env.REACT_APP_ZOHO_ECOMMERCE_NAME,
    ""
);

export const ZOHO_DEFAULT_FILE_EXTENSION = ".xlsx";
